import store from 'store';
import * as NewsActionTypes from 'actiontypes/news';
import NewsService from 'services/NewsService';


const newsService = new NewsService();

/** ----------------------------------------------------------------------------
 * FETCH NEWS ITEM
 -----------------------------------------------------------------------------*/
export const fetch = () => (dispatch) => {
  dispatch(fetchRequested());

  return newsService.fetch().then(
    response => dispatch(fetchSuccess(response.data)),
    error => dispatch(fetchFailure(error)),
  );
};

export const fetchRequested = () => ({
  type: NewsActionTypes.FETCH_NEWS_REQUESTED,
  isFetching: true,
});

export const fetchSuccess = data => ({
  type: NewsActionTypes.FETCH_NEWS_SUCCESS,
  isFetching: false,
  payload: data,
});

export const fetchFailure = error => ({
  type: NewsActionTypes.FETCH_NEWS_FAILURE,
  isFetching: false,
  error: true,
  status: error.response && error.response.status,
});

/** ----------------------------------------------------------------------------
 * DISMISS NEWS ITEM
 -----------------------------------------------------------------------------*/
export const dismissNewsItem = (id) => {
  store.set('dismissed_news_item', id);
  return {
    type: NewsActionTypes.DISMISS_NEWS_ITEM,
    active: false,
  };
};
